// extracted by mini-css-extract-plugin
export default {"p":"_91b7201fdf _1b752a3bcc c4336e890b","clr":"_560a243c49","dls":"d80b31fd6c"};